export const CHANGE_SUBJECT_INFO = 'labroomvideo/CHANGE_SUBJECT_INFO';
export const CHANGE_QUESTION_LIST = 'labroomvideo/CHANGE_QUESTION_LIST';
export const CHANGE_USER_QUESTION_LIST = 'labroomvideo/CHANGE_USER_QUESTION_LIST';
export const CHANGE_OTHER_QUESTION_LIST = 'labroomvideo/CHANGE_OTHER_QUESTION_LIST';
export const CHANGE_FINISHEDLIST = 'labroomvideo/CHANGE_FINISHEDLIST';
export const CHANGE_FINISHEDLIST_LOCK = 'labroomvideo/CHANGE_FINISHEDLIST_LOCK';
export const CHANGE_PLAY_TIME = 'labroomvideo/CHANGE_PLAY_TIME';
export const CHANGE_POP = 'labroomvideo/CHANGE_POP';







